import React from "react";
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";

export default function MuiThemeWrapper({ theme, children }) {
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </StyledEngineProvider>
  );
}
